import PeriprocedureelBeleidTARDaptAsaDip from "../../../../src/client/lta-antistolling/periprocedureel-beleid-tar-dapt-asa-dip.json";
import ChartCollapse from "../../../../src/components/interactions/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  PeriprocedureelBeleidTARDaptAsaDip,
  ChartCollapse,
  React
};